import React from 'react'
import { Typography } from '@mui/material'
const CustomTabLabel = ({label, num}) => {
    return <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
             <Typography>{label}</Typography>
             <span style={{marginLeft:"5px",fontSize:"0.75rem",color:"#999"}}>({num})</span>
         </div>
 }
 export default CustomTabLabel